import React from 'react';
/**
* SimpleSelect class
*
*/
class Input extends React.Component {
   /*
    * State allows React components to change their output over time in response to user actions,
     *network responses, and anything else, without violating this rule
     * React elements are plain objects
     * React DOM compares the element and its children to the previous one,
     * and only applies the DOM updates necessary to bring the DOM to the desired state
     * To render a React element into a root DOM node
     * node whose contents has changed gets updated by React DOM
    */

  classNameCheck() {
    const validation = this.props.form.validation(this.props.fieldName);
    const message = validation ? this.props.state.inputErrors[this.props.fieldName].message : '';
    const classValidation = `form-group ${validation?'feild-wrong':''} ${this.props.value && !validation?'feild-sucess':''}`
    const className = this.props.validation?classValidation:'form-group';
    return {'className':className,'message':message,'validation':validation};
  }

  input(){

    const validation = this.classNameCheck();

    const changeMethod = this.props.onChange || this.props.form.handleFieldsChange;

    return (<React.Fragment><input type={this.props.inputType ? this.props.inputType : "text"}
                                  step={this.props.inputStep ? this.props.inputStep : ""}
                                  data-type={this.props.dataType || "text"}
                                  data-name={this.props.dataName}
                                  placeholder={this.props.labelName}
                                  name={this.props.fieldName}
                                  onBlur={this.props.form.blurEventListner}
                                  disabled={this.props.disabled}
                                  onChange={changeMethod}
                                  value={this.props.value || ''}
                                  data-validation-name={this.props.labelName}
                                  maxLength={this.props.maxLength}/>
                    { validation['validation'] && <p className="error-msg">{validation['message']}</p>}
                  </React.Fragment>);
  }
  /*
  * State allows React components to change their output over time in response to user actions,
   *network responses, and anything else, without violating this rule
   * React elements are plain objects
   * React DOM compares the element and its children to the previous one,
   * and only applies the DOM updates necessary to bring the DOM to the desired state
   * To render a React element into a root DOM node
   * node whose contents has changed gets updated by React DOM
  */
  render() {
    const className = this.classNameCheck();
    const valueCheck = this.props.value?"top":'';

    const defaultForm = (<div className={className['className']}>
                          <div className={'inputgroup '+this.props.divClassName}>
                          {this.input()}
                          <label className={`${valueCheck}`}  onClick={this.props.form.addInputLabelClass}>{this.props.labelName}{ (this.props.validation !== false)  && <sup>*</sup>}</label>
                          <span className="wrong"></span>
                          <span className="eye"></span>
                          <span className="sucess"></span>
                          </div>
                        </div>)

    return (<React.Fragment>
              {this.props.Div ? this.input() : defaultForm}
          </React.Fragment>);
  }
}

export default Input;
